// Common utility to check current browser
export default class UtilityCommon {
  public static getBrowserName(): string {
    if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
      return 'Opera';
    } if (navigator.userAgent.indexOf('Chrome') !== -1) {
      return 'Chrome';
    } if (navigator.userAgent.indexOf('Safari') !== -1) {
      return 'Safari';
    } if (navigator.userAgent.indexOf('Firefox') !== -1) {
      return 'Firefox';
    }
    return 'unknown';
  }

  // To find Tablet device
  public static isTablet(): boolean {
    const ua: any = navigator.userAgent;
     // checking for tablet device
    if ((/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) || (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
      ) || (navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform))) {
      return true;
    }
    return false;
  }

  // To download report for safari
  public static pdfDownloadinSafari(item:number, param:any): void {
    const link: any = document.createElement('a');
    link.href = `/api/pdf/assessment_download/${item}${param}`;
    link.download = `${item}.pdf`;
    link.click();
  }

  public static pdfEULADownloadinSafari(userId: any): void {
    const link: any = document.createElement('a');
    link.href = `/api/pdf/eula/${userId}`;
    link.download = 'EULA.pdf';
    link.click();
  }

  public static pdfTermsDownloadinSafari(userId: any): void {
    const link: any = document.createElement('a');
    link.href = '/api/pdf/terms/download';
    link.download = 'terms.pdf';
    link.click();
  }

  public static pdfPrivacyDownloadinSafari(userId: any): void {
    const link: any = document.createElement('a');
    link.href = '/api/pdf/privacy/download';
    link.download = 'privacy.pdf';
    link.click();
  }
}
